const rootPathToPageType: { [key: string]: string } = {
  account: 'account',
  cart: 'cart',
  checkout: 'checkout',
  collections: 'category',
  'order-confirmed': 'order',
  orders: 'order',
  product: 'product',
  products: 'product',
  returns: 'returns',
  search: 'search',
  'sign-in': 'account',
  'sign-up': 'account',
  'store-locator': 'stores',
};

const pathOverrideRegex: RegExp = new RegExp(
  `^(${['/account/orders', '/orders'].join('|')})`,
);

function getPageType(): string {
  const path: string = window?.location?.pathname ?? '';
  if (path === '/') return 'home';

  const rootPath: string = path.split('/')[1] || '';

  return rootPathToPageType[rootPath] ?? 'otherpages';
}

function getPath(): string {
  const currentPath: string = window?.location?.pathname ?? '';

  // Use the regex to match the current path
  const match: RegExpMatchArray | null = currentPath.match(pathOverrideRegex);

  return match?.[0] ?? currentPath;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function toDataLayer(): Record<string, any> {
  const path: string = getPath();

  return {
    'dom.pathname': path,
    'dom.url': window.location.origin + path,
    location: window.location.origin + path,
    page_type: getPageType(),
  };
}
